import { Component, ElementRef, OnInit, QueryList, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { LoaderService } from '../../../../app/core/services/loading.service';
import data from '../../../../assets/add-new-policy-request.json';
import { AppConfig } from '../../../../config/app-config';
import { PROGRAM_MENU, detailPolicyAccordianData } from '../../../../treo.properties';
import { ProgramService } from '../programs.service';


import moment from 'moment';
import { CommonAgGridHeaderComponent } from '../../../../app/components/common-ag-grid-header/common-ag-grid-header.component';
import { CommonAgGridCellComponent } from '../../../../app/components/common-ag-grid-cell/common-ag-grid-cell.component';
import { HigTealiumNgxService } from 'hig-tealium-ngx';
@Component({
    selector: 'app-service-request-detail',
    templateUrl: './service-request-detail.component.html',
    styleUrls: ['./service-request-detail.component.scss'],
    standalone: false
})
export class ServiceRequestDetailComponent implements OnInit {

    @ViewChild('accordion') accordion: QueryList<ElementRef>;

    serviceRequestVOResponse: any;

    serviceRequestLabel = PROGRAM_MENU;
    updateServiceRequestFormGroup: UntypedFormGroup;
    serviceRequestId: any;
    dateNeeded: string = '';

    // insuredNameInputConfig = AppConfig.insuredNameInputConfig;

    paginationPageSizeReqDetails = 10;
    paginationPageSizeSelectorReqDetails: any[];
    totalRows = 0;
    reqDetailsTableData: any[] = [];
    inputtedNoOfPaperCopies = {};
    totalInputtedNoOfPaperCopies = 0;
    inputtedNoOfEmailCopies = {};
    totalInputtedNoOfEmailCopies = 0;
    requestDetailsColumnDefs: ColDef[] = [
        {
            headerName: ' NAME INSURED ',
            field: 'namedInsured',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            width: 200
        },
        {
            headerName: 'POLICY NUMBER ',
            field: 'policyNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'POLICY PERIOD ',
            field: 'term',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            width: 200
        },
        {
            headerName: 'STATE ',
            field: 'stateDescription',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: '# OF PAPER COPIES',
            field: 'paperCopyNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: '# OF EMAIL COPIES',
            field: 'emailCopyNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'WRITING CO',
            field: 'writingCompanyCode',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        }
    ];

    paginationPageSizeAddReceipents = 10;
    paginationPageSizeSelectorAddReceipents: any[];
    totalRows2 = 0;
    gridApi2: any;
    additionalReceipentsTableData: any[] = [];
    recipientsResponse: any[] = [];
    additionalRecipientsColumnDefs: ColDef[] = [
        {
            headerName: '',
            field: '',
            width: 60,
            headerComponent: CommonAgGridHeaderComponent,
            headerComponentParams: {
                headerType: 'select-all-checkbox',
                label: '',
                listType: 'program-header',
                isRowDataPresent: false,
                class: 'ag-wrapper ag-input-wrapper',
                headerStyle: { 'padding': '1px 0px 6px 24px' }
            },
            headerClass: 'text-center',
            cellClass: 'd-flex justify-content-center align-items-center',
            cellRenderer: CommonAgGridCellComponent,
            cellRendererParams: { 
                tempType: 'program-checkbox' },
            
            headerCheckboxSelectionFilteredOnly: false
        },
        {
            headerName: ' USER OF THIS ACCOUNT ',
            field: 'name',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
        {
            headerName: ' ROLE ',
            field: 'role',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1
        },
    ];

    accordionGridData = data.claimsList.config.dataSource1;
    accordionGridHeader = data.claimsList.config.columnHeaders1;
    accordianData = detailPolicyAccordianData;

    gridApi: any;
    gridApi1: any;
    showEndFileAttachment: boolean = false;
    requestStatus: string = 'Outstanding';
    updateStatusServiceRequestConfig = AppConfig.updateStatusServiceRequestConfig;
    isUpdatedStatusSelectedValid: boolean = true;

    public defaultColDef: ColDef = {
        resizable: false,
        autoHeight: true,
        wrapText: true,
        wrapHeaderText: true
    };

    public JSON = JSON;

    // isStateSelectionValid: boolean = true;

    constructor(private fb: UntypedFormBuilder, private router: Router, public loaderService: LoaderService, public programsService: ProgramService,
         public ngxTealiumService: HigTealiumNgxService,
    ) {
        let udo = {
            site_name: 'TREORiskManagement',
            page_name: 'Policy Service Request',
            component_name: 'Policy Service Request',
            rmis_email: this.loaderService.getItem('emailID'),
            rmis_user_id: this.loaderService.getItem('userId')
        };
        ngxTealiumService.updateUDOObject(udo);
     }

    ngOnInit() {
        const clickedServiceReqType = sessionStorage.getItem('clickedServiceReqType');
        this.requestStatus = clickedServiceReqType ? clickedServiceReqType : 'Outstanding';

        this.updateServiceRequestFormGroup = this.fb.group({
            updatedStatus: ['']

        })
        const serviceRequestId = this.router.url.split('/').pop();
        this.serviceRequestId = serviceRequestId;
        this.retriveContactInfoWC();
    }

    retriveContactInfoWC() {
        this.loaderService.showLoader();
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "RETRIEVE_CONTACT_INFO_WC",
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: null,
            serviceRequestVO: {
                requestNumber: this.serviceRequestId
            }
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.serviceRequestVOResponse = resp.serviceRequestVO;
                this.recipientsResponse = resp.recipients;
                this.fetchReqDetailsTableData();
                this.fetchAddReceipentsTableData();
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    fetchReqDetailsTableData() {
        if (this.serviceRequestVOResponse?.requestDetailVO) {
            this.serviceRequestVOResponse.requestDetailVO.forEach((item: any) => {
                item.namedInsured = this.serviceRequestVOResponse?.insuredName;
            });
        }
        this.reqDetailsTableData = this.serviceRequestVOResponse?.requestDetailVO ?? [];
        this.totalRows = this.reqDetailsTableData.length;
        this.paginationPageSizeReqDetails = 10;
        this.paginationPageSizeSelectorReqDetails = [];
        this.pageSizeOptions();
    }

    fetchAddReceipentsTableData() {
        this.additionalReceipentsTableData = this.recipientsResponse ?? [];
        this.totalRows2 = this.additionalReceipentsTableData.length;
        this.paginationPageSizeAddReceipents = 10;
        this.paginationPageSizeSelectorAddReceipents = [];
        this.pageSizeOptionsAddReceipents();
    }

    updateServiceRequestStatus() {
        this.validateForm();
        if (this.updateServiceRequestFormGroup.valid) {
            this.updateStatusApiCall();
        }
    }

    updateStatusApiCall() {
        const payload = {
            actionType: "SERVICE_REQUEST",
            operation: "UPDATE_SR",
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: null,
            serReqInd: "WC",
            selectedStatus: this.updateServiceRequestFormGroup.get('updatedStatus')?.value,
            serviceRequestVO: {
                requestNumber: this.serviceRequestId,
                requestId: this.serviceRequestVOResponse.requestId
            }
        };
        this.loaderService.showLoader();
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                sessionStorage.setItem('activeServiceReqTab', this.updateServiceRequestFormGroup.get('updatedStatus')?.value);
                this.router.navigate([`/program/service-requests`]);
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    downloadFile(file: any) {
        this.loaderService.showLoader();
        const payload = {
            reportFormat: "RPT",
            reportType: "PROGRAM",
            programRequest: {
                fileName: file.attachmentShortName,
                requestNumber: this.serviceRequestId
            }
        };
        this.programsService.downloadAttachement(payload).subscribe({
            next: (resp) => {
                const blob = new Blob([resp.body], { type: resp.headers.get('content-type') });
                const fileName = payload.programRequest.fileName;
                const file = new File([blob], fileName, { type: resp.headers.get('content-type') });
                FileSaver.saveAs(file, `${fileName}`);
                this.loaderService.hideLoader();
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    validateForm() {
        const formValues = this.updateServiceRequestFormGroup.getRawValue();
        const updatedStatusControl = this.updateServiceRequestFormGroup.get('updatedStatus');
        if (!formValues.updatedStatus) {
            updatedStatusControl.setErrors({ required: true });
            this.isUpdatedStatusSelectedValid = false;
        } else {
            updatedStatusControl.setErrors(null);
            this.isUpdatedStatusSelectedValid = true;
        }
        updatedStatusControl.markAsTouched();
        updatedStatusControl.markAsDirty();
    }

    formateDate(date: any, isUTC?: boolean) {
        if (!date) {
            return '';
        }
        const formattedDate = isUTC ? moment(date).format('MM/DD/YYYY') : moment(date).utc().format('MM/DD/YYYY');
        return formattedDate
    }

    onCellClicked(event: any) {
    }

    onGridReadyReqDetails(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridApi.hideOverlay();
    }

    pageSizeOptions() {
        let maxRange = this.totalRows <= 500 ? this.totalRows + 10 : 500;
        maxRange = this.checkMaxRange(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorReqDetails.push(i);
        }
    }

    checkMaxRange(maxRange?: number) {
        if (maxRange % 10 === 0 && maxRange != 500) {
            maxRange = maxRange - 10;
        }
        return maxRange;
    }

    /* additional Receipeents */

    onCellClickedAddRecp(event: any) {
        console.log('Cell clicked in additional recipients grid:', event);
    }

    onSelectionChangedAddReceipents() {
        const test = this.gridApi2.getSelectedRows();
    }

    onGridReadyAddReceipents(params: GridReadyEvent) {
        this.gridApi2 = params.api;
        this.gridApi2.hideOverlay();
    }
    pageSizeOptionsAddReceipents() {
        let maxRange = this.totalRows2 <= 500 ? this.totalRows2 + 10 : 500;
        maxRange = this.checkMaxRangeAddReceipents(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorAddReceipents.push(i);
        }
    }
    checkMaxRangeAddReceipents(maxRange?: number) {
        if (maxRange % 10 === 0 && maxRange != 500) {
            maxRange = maxRange - 10;
        }
        return maxRange;
    }

    getApplicationId() {
        const encodedId = sessionStorage.getItem('appAccountDetailId');
        if (!encodedId) return null;

        const decodedId = atob(encodedId);
        return Number(decodedId) === 0 ? null : decodedId;
    }

}
